export enum FieldIcon {

  BoolCalc = 'BoolCalc',
  Bool = 'Bool',

  DateCalcContinuous = 'DateCalcContinuous',
  DateCalcDiscrete = 'DateCalcDiscrete',
  DateContinuous = 'DateContinuous',
  DateDiscrete = 'DateDiscrete',

  DateTimeCalcContinuous = 'DateTimeCalcContinuous',
  DateTimeCalcDiscrete = 'DateTimeCalcDiscrete',
  DateTimeContinuous = 'DateTimeContinuous',
  DateTimeDiscrete = 'DateTimeDiscrete',

  GeoCalcContinuous = 'GeoCalcContinuous',
  GeoCalcDiscrete = 'GeoCalcDiscrete',
  GeoContinuous = 'GeoContinuous',
  GeoDiscrete = 'GeoDiscrete',

  Group = 'Group',
  GroupGeo = 'GroupGeo',

  Hierarchy = 'Hierarchy',

  NumberCalcContinuous = 'NumberCalcContinuous',
  NumberCalcDiscrete = 'NumberCalcDiscrete',
  NumberContinuous = 'NumberContinuous',
  NumberDiscrete = 'NumberDiscrete',

  NumericBinDiscrete = 'NumericBinDiscrete',
  NumericBinContinuous = 'NumericBinContinuous',

  Set = 'Set',

  TextCalcContinuous = 'TextCalcContinuous',
  TextCalcDiscrete = 'TextCalcDiscrete',
  TextContinuous = 'TextContinuous',
  TextDiscrete = 'TextDiscrete',

  Unknown = 'Unknown',
}
